import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: [],
  isLoading: false,
  error: {},
  errorCheckEmail: {},
  checkEmail: {},
  token: localStorage.getItem('token') || '',
  profile: JSON.parse(localStorage.getItem('profile')) || '',
  guestPersonal: {},
  errorGuestPersonal: false,
  isLoadingGuestPersonal: false,

  getListArea: [],
  errorGetListArea: false,
  isLoadingGetListArea: false,

  getListIndustry: [],
  errorGetListIndustry: false,
  isLoadingGetListIndustry: false,

  getListTradeRole: [],
  errorGetListTradeRole: false,
  isLoadingGetListTradeRole: false,

  dialcode: [],
  errorDialcode: null,
  isLoadingDialcode: false,

  checkResetpwd: {},
  errorCheckResetpwd: null,
  isLoadingCheckResetpwd: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js